export default __webpack_public_path__ + "static/media/timer_background_xl2.9eaa0ee9.jpg";